import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { AuthProvider } from '@/lib/auth/auth-provider';
import { ApiError } from '@/lib/http';
import { Toaster } from '@/ui/primitives/toaster';

import { roteador } from './rotas';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Erro do cliente (4xx) não melhora tentando de novo; falha de rede/5xx tenta 2 vezes.
      retry: (tentativas, erro) =>
        !(erro instanceof ApiError && erro.status < 500) && tentativas < 2,
    },
  },
});

export function Provedores() {
  return (
    <QueryClientProvider client={cliente}>
      <AuthProvider>
        <RouterProvider router={roteador} />
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
